/**
 * Stocker load-port trays on the instanced overview shell — always visible,
 * independent of simulation state or active transfer overlays.
 */
import React, { useMemo } from 'react';
import { useAppSelector } from '../../hooks/redux';
import type { EquipmentRenderDescriptor } from './equipmentSilhouettePorts';
import StockerLoadPortShell3D, {
  resolveStockerShellLayoutPorts,
  resolveStockerShellMeta,
} from './StockerLoadPortShell3D';
import type { LayoutElement } from '../../types';

type Props = {
  descriptors: EquipmentRenderDescriptor[];
  layoutMeta?: Record<string, Pick<LayoutElement, 'customProperties'>>;
};

const StockerLoadPortsLayer3D: React.FC<Props> = React.memo(({ descriptors, layoutMeta }) => {
  const layoutElements = useAppSelector((s) => s.layout.elements);
  const meta = layoutMeta ?? layoutElements;

  const stockers = useMemo(
    () => descriptors.filter((d) => d.kind === 'stocker'),
    [descriptors]
  );

  if (stockers.length === 0) return null;

  return (
    <group name="StockerLoadPortsLayer3D">
      {stockers.map((descriptor) => {
        const { bayCount, outsideStocker } = resolveStockerShellMeta(descriptor.id, meta);
        const layoutPorts = resolveStockerShellLayoutPorts(descriptor.id, meta);
        return (
          <StockerLoadPortShell3D
            key={descriptor.id}
            descriptor={descriptor}
            bayCount={bayCount}
            outsideStocker={outsideStocker}
            layoutPorts={layoutPorts}
          />
        );
      })}
    </group>
  );
});

StockerLoadPortsLayer3D.displayName = 'StockerLoadPortsLayer3D';

export default StockerLoadPortsLayer3D;
